<script>
	import { push } from 'svelte-spa-router'
	import { sQuery as sq } from './sq'
	import Core from './Core.svelte'
	let name = 'sQuery - Native Speed jQuery for Svelte/SolidJS'
</script>
<Core>
	<h1 class="notranslate">sQuery.js<div>{name}</div></h1>
	
	<doc name="What_is_sQuery">
		<h2>What is sQuery?</h2>
		<div>
			<b>sQuery</b> is like a <red>super minified ES6+ modern jQuery</red>(less than <b>9.5KB</b>) that works great with modern JS frameworks such as <b>Svelte/SolidJS/React/Preact/Vue.js/Angular</b> without any special settings.
			<br><br>
			sQuery is probably something you're looking for especially if you're a modern js framework user but still love jQuery.
			<br><br>
			<i>Have you ever thought the React/Vue virtual DOM is great but you still want a minimum DOM wrapper like jQuery?</i>
			<br><br>
			<i>Have you ever thought repeating <b>document.getElementById</b> or <b>document.querySelectorAll</b> is a stupid idea?</i>
			<br><br>
			I know what you want. You want good old-fashioned simple DOM manipulation methods just like jQuery offers but you don't want to add a <red>300KB+ jQuery file</red> in your project. And you want <blue>native JavaScript speed</blue>, too.
			<br><br>
			Well, sQuery is just 9.5KB, and with Nginx/Apache http Gzipped compression, it would be <red>2.9KB</red>!!
			It offers core jQuery-like functionality such as selector, method chain, dom/css operations, events, fadeIn, fadeOut, animation, each loop, and so on!
			<br><br>
			<div class="cTable">
				<table>
					<thead>
					<tr>
					<th>Size</th>
					<th>sQuery</th>
					<th>Cash</th>
					<th>Zepto 1.2.0</th>
					<th>jQuery Slim 3.6.1</th>
					</tr>
					</thead>
					<tbody>
					<tr>
					<td>Unminified</td>
					<td><strong>13 KB</strong></td>
					<td>36.5 KB</td>
					<td>58.7 KB</td>
					<td><strong>238 KB</strong></td>
					</tr>
					<tr>
					<td>Minified</td>
					<td><strong>9.5KB</strong></td>
					<td>16 KB</td>
					<td>26 KB</td>
					<td><strong>74 KB</strong></td>
					</tr>
					<tr>
					<td>Minified &amp; Gzipped</td>
					<td><strong>2.9 KB</strong></td>
					<td>6 KB</td>
					<td>9.8 KB</td>
					<td><strong>24.8 KB</strong></td>
					</tr>
					</tbody>
				</table>
			</div>
			<br><br>

			Actually, the size of your whole project could be even smaller with sQuery than without it, since you don't have to write lengthy native DOM codes over and over again. (Also, more good news: sQuery is basically the same speed as native codes!)
			<br><br>
			sQuery is NOT exactly like jQuery but rather a super simple esential DOM library with near-native speed that takes your development experience to the next level.
			<br><br>
			<h3><i>sQuery's 'S' is for Simple, Small, Speed, and Solid</i></h3>
		</div>
	</doc>

	<doc name="Installation">
		<h2>Read the documentation and start!</h2>
		<div>
			There are CDN/zip/module/npm options for sQuery.<br>
			If you already know jQuery, you basically don't need any additional knowledge.
			Let's go to the <a href="./#/docs">documentation</a> page and start!
		</div>
	</doc>

	<div>
		<a href="./?n=Use_with_React#/install"><img class="cCLogo" alt="" src="img/react.png"></a>
		<a href="./?n=Use_with_Vue#/install"><img class="cCLogo" alt="" src="img/vuejs.png"></a>
		<a href="./?n=Use_with_Svelte#/install"><img class="cCLogo" alt="" src="img/svelte.png"></a>
		<a href="./?n=Use_with_SolidJS#/install"><img class="cCLogo" alt="" src="img/solidjs.jpg"></a>
		<a href="./?n=Use_with_Angular#/install"><img class="cCLogo" alt="" src="img/angular.png"></a>
		<a href="./?n=Use_with_Next#/install"><img class="cCLogo" alt="" src="img/next.png"></a>
		<a href="./?n=Use_with_Nuxt#/install"><img class="cCLogo" alt="" src="img/nuxt.png"></a>
		<a href="./?n=Use_with_Sveltekit#/install"><img class="cCLogo" alt="" src="img/sveltekit.png"></a>
		<img class="cCLogo" alt="" src="img/squery.jpg">
	</div>
</Core>

